import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
interface HeroSectionProps {
  onScrollToPurchase: () => void;
}
export function HeroSection({
  onScrollToPurchase
}: HeroSectionProps) {
  const benefits = ['Material teórico completo por nivel', 'Más de 500 actividades listas para usar', 'Planificación anual de clases', 'Diapositivas preparadas para explicar procesos históricos'];
  return <section className="bg-white py-6 md:py-10 px-4 pl-[9px] pr-[9px]" data-id="element-92">
      <div className="max-w-4xl mx-auto text-center" data-id="element-93">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-3xl md:text-5xl font-extrabold text-[#424E60] leading-tight mb-3 uppercase" data-id="element-94">
          Manual Académico de Historia para Docentes
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mb-5" data-id="element-95">
          <span className="inline-flex items-center gap-2 bg-[#4A7C59] text-white text-xs md:text-sm font-bold uppercase tracking-wider px-5 py-2 rounded-full shadow-md pt-[3px] pb-[3px]" data-id="element-96">
            <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 shrink-0" data-id="element-97">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" data-id="element-98" />
            </svg>
            Para docentes de Historia de nivel secundario
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="max-w-xl mx-auto mb-2 relative overflow-hidden" data-id="element-99">
          <img src="https://cdn.magicpatterns.com/uploads/8EcbD23hSb5TCKFyB81aeL/Diseno_sin_titulo_(5).png" alt="Manual Académico Historia para Docentes - Colección Completa" className="w-full h-auto -mt-4 -mb-6" data-id="element-100" />
        </motion.div>

        <motion.h3 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="text-lg md:text-xl font-bold text-[#424E60] mb-4" data-id="element-101">
          La colección de Historia que puede ahorrarte decenas de horas de
          planificación este año
        </motion.h3>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="text-base md:text-lg text-[#424E60] mb-6 max-w-3xl mx-auto leading-relaxed" data-id="element-102">
          Material completo para enseñar Historia de 1° a 5° año de secundaria,
          con contenidos, actividades, planificación y diapositivas listas para
          usar.
          <br data-id="element-103" />
          <br data-id="element-104" />
          Empieza el año con gran parte de tu trabajo docente ya organizado.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="bg-[#F4F4F2] rounded-xl p-5 md:p-6 text-left max-w-2xl mx-auto border border-[#E2DED6]" data-id="element-105">
          <ul className="space-y-3" data-id="element-106">
            {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-107">
                <CheckCircle2 className="text-[#4A7C59] shrink-0 mt-0.5" size={20} data-id="element-108" />
                <span className="text-[#424E60] font-bold text-base md:text-lg" data-id="element-109">
                  {benefit}
                </span>
              </li>)}
          </ul>

          <div className="mt-6" data-id="element-110">
            <CTAButton onClick={onScrollToPurchase} data-id="element-111">
              Acceder a la colección completa
            </CTAButton>
          </div>
        </motion.div>
      </div>
    </section>;
}